import { render, staticRenderFns } from "./NoPendingOrders.vue?vue&type=template&id=9df2d01e&"
import script from "./NoPendingOrders.vue?vue&type=script&lang=js&"
export * from "./NoPendingOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports